import React from "react";

const InputBox = ({
  label,
  placeholder,
  value,
  name,
  onChange,
  type = "text",
  required = false,
  rows = 5,
}) => {
  const isTextarea = type === "textarea";

  return (
    <div className="field-group">
      {label && (
        <label htmlFor={name} className="field-label">
          {label}
        </label>
      )}

      {isTextarea ? (
        <textarea
          id={name}
          className="input-box textarea-box"
          placeholder={placeholder || label}
          value={value}
          onChange={onChange}
          name={name}
          rows={rows}
          required={required}
        />
      ) : (
        <input
          id={name}
          className="input-box"
          style={{}}
          placeholder={placeholder || label}
          value={value}
          onChange={onChange}
          name={name}
          type={type}
          required={required}
        />
      )}
    </div>
  );
};

export default InputBox;
